// TenantSecret endpoints. Plaintext is base64-encoded on the wire;
// the server decodes once and never echoes any secret material back.
// The list and detail responses are metadata-only.

import { request, type ApiResponse } from "../client";
import type {
  TenantSecretCreate,
  TenantSecretOut,
} from "../types/tenantSecret";

export const tenantSecrets = {
  list: (
    accountSlug: string,
    tenantSlug: string,
  ): Promise<ApiResponse<TenantSecretOut[]>> =>
    request<TenantSecretOut[]>(
      "GET",
      `/api/v1/accounts/${encodeURIComponent(accountSlug)}/tenants/${encodeURIComponent(tenantSlug)}/secrets`,
    ),

  get: (
    accountSlug: string,
    tenantSlug: string,
    secretId: string,
  ): Promise<ApiResponse<TenantSecretOut>> =>
    request<TenantSecretOut>(
      "GET",
      `/api/v1/accounts/${encodeURIComponent(accountSlug)}/tenants/${encodeURIComponent(tenantSlug)}/secrets/${encodeURIComponent(secretId)}`,
    ),

  create: (
    accountSlug: string,
    tenantSlug: string,
    body: TenantSecretCreate,
  ): Promise<ApiResponse<TenantSecretOut>> =>
    request<TenantSecretOut>(
      "POST",
      `/api/v1/accounts/${encodeURIComponent(accountSlug)}/tenants/${encodeURIComponent(tenantSlug)}/secrets`,
      body,
    ),
};
